export default __webpack_public_path__ + "static/media/expose1.dc785a8e.png";